module.exports = __webpack_public_path__ + "img/dc2.f9426b5a.png";